// extracted by mini-css-extract-plugin
export var active = "_g4-2";
export var recordingDot = "_g4-1";
export var recordingIndicator = "_g4-0";